export enum QualificationAccountAnketaEnum {
	professional = 'professional',
	retailInvestor = 'retail_investor',
}
